import {
  CheckOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  checked: boolean;
  loading?: boolean;
}

export const IconCheckControl = ({ checked, loading }: Props) => {
  if (loading) {
    return <LoadingOutlined style={{ color: "var(--ant-green)" }} />;
  }
  if (checked) {
    return <CheckOutlined style={{ color: "var(--ant-green)" }} />;
  }
  return <CloseOutlined style={{ color: "var(--ant-red)" }} />;
};
